import { useMemo } from "react";

import { useSelector } from "react-redux";

import { RootState } from "@store/store";
import { PermissionV2 } from "@interfaces/users";

export function useGetPermission(code: string): PermissionV2 | undefined {
    const userSession = useSelector((state: RootState) => state.session.user);
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);
    const userPermissionsForest = useSelector((state: RootState) => state.session.permissionsV2);

    const findPermission = (permissions: Array<PermissionV2>, code: string): PermissionV2 | undefined => {
        for (const permission of permissions) {
            if (permission.code === code) return permission;

            if (permission.children) {
                const found = findPermission(permission.children, code);
                if (found) return found;
            }
        }
        return undefined;
    };

    const onlyRead = (permission: Array<PermissionV2>): Array<PermissionV2> => {
        return permission.map((p) => ({
            ...p,
            can_confirm: false,
            can_edit: false,
            can_reject: false,
            can_upload: false,
            children: onlyRead(p.children),
        }));
    };

    return useMemo(() => {
        const permission = findPermission(userPermissionsForest, code);

        if (
            permission !== undefined &&
            ["CSRER", "CSRES", "CSRDO", "CSRFO", "CSRCO", "CSCLI", "CAOAC", "CSORC"].includes(
                applicationSelected.status_code,
            ) &&
            userSession.role.code !== "RADM2"
        ) {
            return {
                ...permission,
                can_confirm: false,
                can_edit: false,
                can_reject: false,
                can_upload: false,
                children: onlyRead(permission.children),
            };
        }

        return permission;
    }, [userPermissionsForest]);
}
